module.exports = __webpack_public_path__ + "img/gallery_hover.64c24967.svg";